import { SvgIcon } from '@mui/material';

export default function ArrowRightIcon(props: any) {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20" style={{ ...props.style, width: `24px`, height: `24px` }}>
      <path d="M8.55664 5L15.5566 12L8.55664 19" fill="transparent" stroke-linecap="round" stroke-linejoin="round" />,
    </SvgIcon>
  );
}
